<template>
    <b-nav-item-dropdown right
    >
        <template v-slot:button-content>
            <span class="text-uppercase">{{ $i18n.locale }}</span>
        </template>
        <b-dropdown-item
            href="#"
            v-for="locale in locales"
            :key="locale.code"
            @click.prevent="emitChangeEvent(locale.code)"
        >{{ locale.name }}</b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
    import { getSupportedLocales } from "../../utils/i18n/supported-locales";

    /**
     * Dropdown for switching languages in the navbar.
     */

    export default {
        name: "LocaleSwitcher",
        data() {
            return {
                locales: getSupportedLocales(),
                selectedLocale: ''
            }
        },
        methods: {
            emitChangeEvent(value) {
                this.$emit('change', value);
            }
        }
    }
</script>

<style scoped>

</style>